/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractVariantDto } from '../../models/backend-leasing-contract-variant-dto';

export interface FinancingSourcesLeasingsVariantsRetrieve$Params {
  /**
   * A unique integer value identifying this leasing contract variant.
   */
  id: number;
}

export function financingSourcesLeasingsVariantsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsVariantsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsVariantsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractVariantDto>;
    }),
  );
}

financingSourcesLeasingsVariantsRetrieve.PATH = '/api/financing_sources/leasings_variants/{id}/';
